export const PARTS_RESET = 'parts/reset'
export const PARTS_ADD = 'parts/add'
export const CHANGE_SIZE = 'stamp/size'
export const ROLE_CHANGE = 'parts/roleChange'
export const PARTS_REMOVE = 'parts/remove'
export const SET_FOCUS = 'parts/focus'
export const CONT_RESET = 'contract/reset'
export const BOX_ADD = 'stamps/add'